import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6 m-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_trial_info = _resolveComponent("trial-info")!
  const _component_trial_expired = _resolveComponent("trial-expired")!
  const _component_subscription_expired = _resolveComponent("subscription-expired")!
  const _component_subscription_info = _resolveComponent("subscription-info")!
  const _component_subscription_change = _resolveComponent("subscription-change")!
  const _component_billing_info_change = _resolveComponent("billing-info-change")!
  const _component_collapsable_container = _resolveComponent("collapsable-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isExist())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.isTrial() && !_ctx.isExpired())
            ? (_openBlock(), _createBlock(_component_trial_info, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.isTrial() && _ctx.isExpired())
            ? (_openBlock(), _createBlock(_component_trial_expired, { key: 1 }))
            : _createCommentVNode("", true),
          (!_ctx.isTrial() && _ctx.isExpired())
            ? (_openBlock(), _createBlock(_component_subscription_expired, { key: 2 }))
            : _createCommentVNode("", true),
          (!_ctx.isTrial() && !_ctx.isExpired())
            ? (_openBlock(), _createBlock(_component_subscription_info, {
                key: 3,
                onToggleSubChangeBlock: _ctx.toggleSubChangeBlock,
                onToggleBillingInfoChangeBlock: _ctx.toggleBillingInfoChangeBlock
              }, null, 8, ["onToggleSubChangeBlock", "onToggleBillingInfoChangeBlock"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_subscription_change, {
      show: _ctx.subChangeShowed()
    }, null, 8, ["show"]),
    _createVNode(_component_collapsable_container, { show: _ctx.showBillingInfoChange }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_billing_info_change, {
              onBillingInfoUpdated: _ctx.toggleBillingInfoChangeBlock,
              changeEnabled: true,
              changeCancelEnabled: false
            }, null, 8, ["onBillingInfoUpdated"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}